export default __webpack_public_path__ + "static/media/ref-perla-pszczyna.345165e8.pdf";